module.exports = __webpack_public_path__ + "img/1-3.439559f2.png";